const getErrorMessage = (
  error: unknown,
  fallback = "Erro inesperado. Tente novamente."
): string => {
  const err = error as {
    response?: { data?: { message?: string } };
    message?: string;
  };

  return err?.response?.data?.message || err?.message || fallback;
};

export default getErrorMessage;
